import { COLORS } from 'helpers/globals'
import contextMenu from 'helpers/styles/contextMenu'
const button = {
  fontSize: '2rem',
  alignItems: 'center',
  justifyContent: 'center',
  width: '25%'
}
export default {
  instructions: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`,
  },
  measurementText: {
    fontSize: '2rem',
    padding: '1rem',
    paddingBottom: '0rem !important'
  },
  measurementDisplayText: {
    fontSize: '3.2rem',
    padding: '1rem',
    paddingTop: '0rem !important',
    color: 'black'
  },
  goBackButton: {
    marginRight: 7
  },
  copyButton: {
    ...button,
    marginLeft: '5%',
    color: COLORS.primary,
    display: 'inline',
    '& svg.fa-inverse': { color: COLORS.primary },
    '&:hover:not(.blockClick)': {
      cursor: 'pointer',
      color: '#2972B1',
      '& svg.fa-inverse': { color: '#2972B1' }
    }
  },
  cancelButton: {
    ...button,
    backgroundColor: 'red',
    display: 'flex',
    '& svg.fa-inverse': { color: COLORS.quaternary },
    '&:hover:not(.blockClick)': {
      cursor: 'pointer',
      background: 'darkred',
      '& svg.fa-inverse': { color: COLORS.quaternary }
    },
    padding: '1%',
    color: 'white'
  },
  clipboardButton: {
    marginLeft: '1%'
  },
  cancelButtonIcon: {
    marginLeft: '5%',
  },
  MeasurementLineOverlay: {
    backgroundColor: 'white',
    display: 'inline',
    padding: '.5rem',
    lineHeight: '.5rem',
    position: 'absolute'
  },
  ...contextMenu
}



// WEBPACK FOOTER //
// ./src/components/MeasurementDetailsPanel/style.js